import React from 'react';
import { motion } from 'framer-motion';
import { BookOpenIcon, CalendarDaysIcon, CheckIcon, Clock3Icon, CookingPotIcon, DownloadIcon, LeafIcon, LockKeyholeIcon, MonitorSmartphoneIcon, NotebookPenIcon, SaladIcon, SparklesIcon, ZapIcon } from 'lucide-react';
import { checkoutUrl, handleCheckoutClick } from '../utils/checkout';
const products = [{
  label: 'PRODUCTO PRINCIPAL',
  title: 'CÓDIGO FITNESS™',
  icon: BookOpenIcon,
  description: 'La guía principal donde aprenderás, paso a paso, cómo comer saludable sin pasar hambre.',
  image: 'https://cdn.magicpatterns.com/uploads/8qqeT9itbTEfWdJ6h8w9LR/ChatGPT_Image_17_jul_2026,_09_37_05.png',
  benefits: ['Qué comer', 'Cómo crear hábitos saludables', 'Cómo organizar tus comidas', 'Calendario de alimentación de 30 días', 'Más de 300 recetas saludables', 'Planes completos', 'Meal Prep', 'Explicaciones fáciles para principiantes'],
  featured: true
}, {
  label: 'BONO PREMIUM #1',
  title: 'Cocina Antiinflamatoria',
  icon: SaladIcon,
  description: 'Más de 130 recetas saludables, jugos verdes y smoothies para ayudarte a reducir la inflamación mientras disfrutas comida deliciosa todos los días.',
  image: 'https://cdn.magicpatterns.com/uploads/ew4zYGVwXbmFnKLfyms136/bono_3_CF.png',
  benefits: ['Desayunos', 'Almuerzos', 'Cenas', 'Snacks', 'Jugos verdes', 'Smoothies', 'Sopas', 'Postres saludables', 'Ingredientes fáciles de conseguir', 'Preparación paso a paso'],
  featured: false
}, {
  label: 'BONO PREMIUM #2',
  title: 'Recetario Déficit Calórico',
  icon: CookingPotIcon,
  description: 'Aprende a perder grasa sin pasar hambre gracias a un recetario diseñado para crear un déficit calórico de forma saludable.',
  image: 'https://cdn.magicpatterns.com/uploads/wzKGsUFS67E9tmbeSAkRpg/bono_2_CF.png',
  benefits: ['Más de 120 recetas', 'Altas en proteína', 'Bajas en calorías', 'Desayunos', 'Almuerzos', 'Cenas', 'Meriendas', 'Postres Fitness', 'Información nutricional', 'Meal Prep', 'Recetas listas en menos de 30 minutos'],
  featured: false
}, {
  label: 'BONO PREMIUM #3',
  title: 'Planificador Nutricional',
  icon: CalendarDaysIcon,
  description: 'La herramienta perfecta para organizar tu alimentación y convertir los buenos hábitos en un estilo de vida.',
  image: 'https://cdn.magicpatterns.com/uploads/qa3vi2EPaBMrMf36ySks4p/bono_1_CF.png',
  benefits: ['Planificador semanal', 'Organización diaria', 'Seguimiento de agua', 'Seguimiento de ejercicio', 'Registro de hábitos', 'Lista inteligente de compras', 'Control de progreso', 'Espacio para notas', 'Objetivos semanales'],
  featured: false
}];
const learning = [['Aprender a comer saludable', LeafIcon], ['Organizar tus comidas', NotebookPenIcon], ['Crear hábitos que perduran', SparklesIcon], ['Preparar desayunos', CookingPotIcon], ['Preparar almuerzos', SaladIcon], ['Preparar cenas', CookingPotIcon], ['Preparar meriendas', SaladIcon], ['Meal Prep', Clock3Icon], ['Déficit calórico', LeafIcon], ['Cocina antiinflamatoria', SparklesIcon], ['Jugos verdes', SaladIcon], ['Smoothies saludables', LeafIcon]];
export function OfferLearning() {
  return <>
      <section id="incluye" className="relative overflow-hidden bg-[#fffefa] py-24 sm:py-32" data-id="element-171" data-mp="2qaotn56jemb9">
        <LeafIcon aria-hidden="true" className="absolute -right-10 top-40 h-36 w-36 rotate-[24deg] text-[#e2eadc]" strokeWidth={0.9} data-id="element-172" data-mp="2v7xa91c1eiae" />
        <div className="relative mx-auto max-w-7xl px-5 sm:px-8" data-id="element-173" data-mp="22jrr2j0mt1co">
          <header className="mx-auto max-w-4xl text-center" data-id="element-174" data-mp="27j4dj2nlc6eq">
            <p className="text-xs font-bold tracking-[0.2em] text-[#6d8063]" data-id="element-175" data-mp="27hkvb6idjlab">
              ACCESO DIGITAL INMEDIATO
            </p>
            <h2 className="font-display mt-5 text-4xl leading-tight text-[#2d3b2c] sm:text-5xl" data-id="element-176" data-mp="923vbovpu6m1">
              Todo lo que necesitas para transformar tu alimentación… en un solo
              sistema.
            </h2>
            <div className="mx-auto mt-7 max-w-3xl space-y-5 text-lg leading-8 text-[#63705f]" data-id="element-177" data-mp="i2a5b0s7gogg">
              <p data-id="element-178" data-mp="wqn5k9ybstgr">No estás comprando un simple libro digital.</p>
              <p data-id="element-179" data-mp="rsbww2jrop04">
                Estás invirtiendo en un sistema completo creado para ayudarte a
                comer mejor todos los días, organizar tus comidas con facilidad
                y construir hábitos saludables que puedas mantener durante toda
                la vida.
              </p>
              <p data-id="element-180" data-mp="37jhnu9mbgoxt">
                Cada guía, cada receta y cada herramienta fue diseñada para que
                cuidar tu alimentación deje de sentirse complicado y empiece a
                convertirse en una experiencia práctica, agradable y sostenible.
              </p>
            </div>
          </header>

          <motion.article initial={{
          opacity: 0,
          y: 18
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          amount: 0.1
        }} transition={{
          duration: 0.55
        }} className="mt-16 overflow-hidden border border-[#e0e4da] bg-[#fcfbf7] shadow-[0_12px_34px_rgba(53,70,49,0.07)] lg:grid lg:grid-cols-[.76fr_1.24fr] lg:items-stretch" data-id="element-181" data-mp="1n15pmfsc9myz">
            <div className="relative flex min-h-[420px] items-center justify-center bg-[#eef1e7] p-8 sm:p-12 lg:min-h-[640px]" data-id="element-182" data-mp="qcr4zs3zz95a">
              <span className="absolute left-6 top-6 bg-[#fffefa] px-3 py-2 text-[10px] font-bold tracking-[0.16em] text-[#52664c] shadow-sm" data-id="element-183" data-mp="uekx3c04n4tu">
                PRODUCTO PRINCIPAL
              </span>
              <img src={products[0].image} alt="Portada de la guía Código Fitness" className="relative h-auto max-h-[530px] w-auto max-w-[330px] object-contain shadow-[14px_20px_32px_rgba(38,48,35,0.22)] sm:max-w-[400px]" data-id="element-184" data-mp="2oog6y3be8v8c" />
            </div>

            <div className="p-8 sm:p-12 lg:p-14" data-id="element-185" data-mp="3jny8xizq2qtl">
              <div className="flex items-center gap-3 text-[#66805c]" data-id="element-186" data-mp="3jp9lo8b5b8wu">
                <LeafIcon size={21} strokeWidth={1.5} aria-hidden="true" data-id="element-187" data-mp="k9crvpjn8m87" />
                <p className="text-[11px] font-bold tracking-[0.16em]" data-id="element-188" data-mp="g77vwk5q3die">
                  🌿 TU GUÍA PRINCIPAL
                </p>
              </div>
              <h3 className="font-display mt-5 text-3xl text-[#30452e] sm:text-4xl" data-id="element-189" data-mp="bf8279g8xgu9">
                CÓDIGO FITNESS™
              </h3>
              <p className="mt-4 max-w-xl text-lg leading-8 text-[#42573f]" data-id="element-190" data-mp="6flpd14by2lz">
                El método paso a paso que te ayudará a comer saludable sin pasar
                hambre y sin complicarte la vida.
              </p>

              <div className="mt-7 max-w-2xl space-y-4 leading-7 text-[#62705f]" data-id="element-191" data-mp="16hrvesc4rkya">
                <p data-id="element-192" data-mp="1bgbkh1m0tcuv">
                  Esta es la guía que reúne todo lo que necesitas para comenzar
                  desde cero.
                </p>
                <p data-id="element-193" data-mp="1gemtxb8ellck">
                  Aprenderás cómo organizar tus comidas, preparar recetas
                  saludables, crear hábitos duraderos y sentirte mejor con una
                  alimentación práctica y deliciosa.
                </p>
                <p data-id="element-194" data-mp="1uf7d48i8dj6l">
                  No importa si nunca antes has seguido un plan nutricional.
                </p>
                <p data-id="element-195" data-mp="1z5dxtx9mgjjk">
                  Todo está explicado de forma sencilla, con ejemplos claros y
                  herramientas listas para aplicar desde el primer día.
                </p>
              </div>

              <h4 className="mt-9 text-[11px] font-bold uppercase tracking-[0.16em] text-[#52664c]" data-id="element-196" data-mp="287dgsv475xp5">
                Con esta guía aprenderás a:
              </h4>
              <ul className="mt-5 grid gap-x-7 gap-y-3 sm:grid-cols-2" data-id="element-197" data-mp="2d3c8osoqhxub">
                {['Comer saludable sin sentir que estás haciendo una dieta.', 'Organizar todas tus comidas de la semana.', 'Crear hábitos fáciles de mantener.', 'Preparar más de 300 recetas saludables.', 'Seguir un calendario completo de alimentación durante 30 días.', 'Ahorrar tiempo gracias al Meal Prep.', 'Tener siempre ideas saludables para desayunos, almuerzos, cenas y meriendas.', 'Disfrutar la comida mientras cuidas de tu salud.'].map(benefit => <li key={benefit} className="flex items-start gap-2.5 text-sm leading-6 text-[#586655]" data-id="element-198" data-mp="2phs5zxpeu2nh">
                    <CheckIcon className="mt-1 shrink-0 text-[#719063]" size={15} strokeWidth={2} data-id="element-199" data-mp="1wy3c6kgved7u" />
                    <span data-id="element-200" data-mp="7hqynasi11fd">{benefit}</span>
                  </li>)}
              </ul>

              <aside className="mt-9 rounded-2xl border border-[#d8e5d0] bg-[#eff5ea] p-6 sm:p-7" data-id="element-201" data-mp="ca0uf7gaovpk">
                <h4 className="font-display text-2xl text-[#354a33]" data-id="element-202" data-mp="3tr1wd3s1ndja">
                  Lo mejor de Código Fitness™
                </h4>
                <div className="mt-4 space-y-2.5 text-sm leading-6 text-[#53634e]" data-id="element-203" data-mp="2h38erc3gom7">
                  <p data-id="element-204" data-mp="q9tlj3vqhdy2">No necesitas contar calorías todo el tiempo.</p>
                  <p data-id="element-205" data-mp="v71zes9umvti">
                    No necesitas eliminar todos los alimentos que disfrutas.
                  </p>
                  <p data-id="element-206" data-mp="h82dvthmux1k">No necesitas seguir dietas extremas.</p>
                  <p className="font-semibold text-[#405a3b]" data-id="element-207" data-mp="l95uwjbf2z4d">
                    Solo necesitas seguir el sistema paso a paso.
                  </p>
                </div>
              </aside>

              <div className="mt-7" data-id="element-208" data-mp="360o6njwxlqrv">
                <a href={checkoutUrl} onClick={handleCheckoutClick} className="inline-flex min-h-14 w-full items-center justify-center rounded-full bg-[#405a3b] px-7 text-center text-sm font-bold tracking-[0.06em] text-white shadow-[0_10px_20px_rgba(48,69,46,0.14)] transition duration-300 hover:-translate-y-0.5 hover:bg-[#304a2d] hover:shadow-[0_14px_25px_rgba(48,69,46,0.2)] sm:w-auto" data-id="element-209" data-mp="361pqodvxdnlq">
                  🍃 QUIERO COMENZAR HOY
                </a>
                <div className="mt-4 flex flex-wrap gap-x-3 gap-y-2 text-xs font-medium text-[#64745f]" data-id="element-210" data-mp="3jdquympfjy13">
                  <span data-id="element-211" data-mp="3o84kw9lbpcyd">🔒 Pago 100% seguro</span>
                  <span className="text-[#9aa893]" data-id="element-212" data-mp="3abr9ni7du7sc">•</span>
                  <span data-id="element-213" data-mp="3ecb60jk4t7df">⚡ Acceso inmediato</span>
                  <span className="text-[#9aa893]" data-id="element-214" data-mp="3ed2wjfyvgewu">•</span>
                  <span data-id="element-215" data-mp="18jmfs16bp0ez">📥 Descarga digital</span>
                  <span className="text-[#9aa893]" data-id="element-216" data-mp="18juttwe6mbrr">•</span>
                  <span data-id="element-217" data-mp="1clg7hjyjiu30">📱 Compatible con celular, tablet y computadora</span>
                  <span className="text-[#9aa893]" data-id="element-218" data-mp="2x2yzqf1dvakr">•</span>
                  <span data-id="element-219" data-mp="2x3iitz2rs50d">💚 Pago único</span>
                </div>
                <p className="font-display mt-7 max-w-2xl text-xl leading-8 text-[#3e573a] sm:text-2xl" data-id="element-220" data-mp="2t26o5f51gtlb">
                  Cada pequeño cambio que hagas hoy puede convertirse en una
                  vida más saludable mañana. Código Fitness™ será la guía que
                  te acompañará en ese camino, con recetas deliciosas,
                  herramientas prácticas y un método diseñado para personas
                  reales como tú.
                </p>
              </div>
            </div>
          </motion.article>

          <div className="mx-auto mt-10 max-w-4xl border-y border-[#dce5d5] py-8 text-center" data-id="element-221" data-mp="3pqcv48pfny2r">
            <p className="font-display text-2xl text-[#3b5538] sm:text-3xl" data-id="element-222" data-mp="3ktuvtocvgrxt">
              Y esto es solo el comienzo…
            </p>
            <p className="mx-auto mt-3 max-w-2xl leading-7 text-[#62705f]" data-id="element-223" data-mp="1vfgbdg8vzr84">
              Al comprar Código Fitness™ también recibirás tres bonos
              exclusivos valorados en más de $90, incluidos sin costo adicional.
            </p>
            <span aria-hidden="true" className="mt-5 block text-2xl text-[#69845f]" data-id="element-224" data-mp="3vf360i2ow9ya">
              ↓
            </span>
          </div>

          <div className="mt-10 grid gap-8 lg:grid-cols-2" data-id="element-225" data-mp="8ax23unc6nyc">
            {products.slice(1).map((product, index) => {
            const ProductIcon = product.icon;
            return <motion.article key={product.title} initial={{
              opacity: 0,
              y: 18
            }} whileInView={{
              opacity: 1,
              y: 0
            }} viewport={{
              once: true,
              amount: 0.1
            }} transition={{
              duration: 0.5,
              delay: index * 0.05
            }} className="overflow-hidden border border-[#e0e4da] bg-[#fcfbf7] shadow-[0_12px_34px_rgba(53,70,49,0.07)]" data-id="element-226" data-mp="i9crnt6ptp5q" data-mpi={index}>
                  <div className="relative flex min-h-[350px] items-center justify-center bg-[#eef1e7] p-8 sm:min-h-[410px]" data-id="element-227" data-mp="2gkwi9gwllqnb">
                    <span className="absolute left-6 top-6 bg-[#fffefa] px-3 py-2 text-[10px] font-bold tracking-[0.16em] text-[#52664c] shadow-sm" data-id="element-228" data-mp="27idgz18gnm36">
                      {product.label}
                    </span>
                    <img src={product.image} alt={`Portada de ${product.title}`} className="relative h-auto max-h-[490px] w-auto max-w-[250px] object-contain shadow-[14px_20px_32px_rgba(38,48,35,0.22)] sm:max-w-[290px]" data-id="element-229" data-mp="306j1bmvlr92h" />
                  </div>
                  <div className="p-7 sm:p-9" data-id="element-230" data-mp="3nxwutw5hpap1">
                    <div className="flex items-center gap-3 text-[#66805c]" data-id="element-231" data-mp="3j5wzkh0d75ys">
                      <ProductIcon size={21} strokeWidth={1.5} aria-hidden="true" data-id="element-232" data-mp="3j3slx7cnyslb" />
                      <p className="text-[11px] font-bold tracking-[0.16em]" data-id="element-233" data-mp="37qs8cfvkta7w">
                        {product.label}
                      </p>
                    </div>
                    <h3 className="font-display mt-5 text-3xl text-[#30452e]" data-id="element-234" data-mp="2ynr8uy17uhd7">
                      {product.title}
                    </h3>
                    <p className="mt-4 max-w-xl leading-7 text-[#62705f]" data-id="element-235" data-mp="3mg7zhwz0rho4">
                      {product.description}
                    </p>
                    <h4 className="mt-8 text-[11px] font-bold uppercase tracking-[0.16em] text-[#52664c]" data-id="element-236" data-mp="3cotuxas7nro4">
                      Incluye
                    </h4>
                    <ul className="mt-4 grid gap-x-6 gap-y-2.5 sm:grid-cols-2" data-id="element-237" data-mp="3hlak88b5cc2s">
                      {product.benefits.map(benefit => <li key={benefit} className="flex items-start gap-2 text-sm leading-6 text-[#586655]" data-id="element-238" data-mp="dyjw3y9uw40c">
                          <CheckIcon className="mt-1 shrink-0 text-[#719063]" size={14} strokeWidth={2} data-id="element-239" data-mp="jc1sjj71w6wo" />
                          <span data-id="element-240" data-mp="s3kanznk4wse">{benefit}</span>
                        </li>)}
                    </ul>
                  </div>
                </motion.article>;
          })}

            <motion.aside initial={{
            opacity: 0,
            y: 18
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true,
            amount: 0.1
          }} transition={{
            duration: 0.5,
            delay: 0.18
          }} className="overflow-hidden rounded-2xl border border-[#dfe5d8] bg-[#fffefa] shadow-[0_14px_35px_rgba(53,70,49,0.10)]" aria-labelledby="complete-system-title" data-id="element-241" data-mp="dpfvngxkewc">
              <div className="bg-[#f2f3eb] p-4 sm:p-6" data-id="element-242" data-mp="1wsz8fncgzv4g">
                <img src="https://cdn.magicpatterns.com/uploads/aR4AkNTxrSX6UMBq73ffAA/productos_completo_CF.png" alt="Sistema completo Código Fitness con guía principal, cocina antiinflamatoria, recetario déficit calórico y planificador nutricional" className="h-auto w-full rounded-xl object-contain shadow-[0_10px_25px_rgba(48,64,43,0.13)]" data-id="element-243" data-mp="21tdfb22c4z0w" />
              </div>
              <div className="p-7 sm:p-9" data-id="element-244" data-mp="1j1t49dy8x9b8">
                <p className="text-[11px] font-bold tracking-[0.16em] text-[#66805c]" data-id="element-245" data-mp="1nu44yj0t8z4u">
                  PACK PREMIUM
                </p>
                <h3 id="complete-system-title" className="font-display mt-4 text-3xl leading-tight text-[#30452e]" data-id="element-246" data-mp="qdory9l65xzk">
                  Todo el sistema completo incluido
                </h3>
                <p className="mt-4 leading-7 text-[#62705f]" data-id="element-247" data-mp="nrxxcndd38qf">
                  No estás comprando un solo libro. Hoy recibes un ecosistema
                  completo creado para ayudarte a transformar tu alimentación de
                  una forma práctica, sencilla y sostenible.
                </p>
                <p className="mt-4 leading-7 text-[#62705f]" data-id="element-248" data-mp="8zduzoy1d5a1">
                  Más de 550 recetas saludables, planes de alimentación,
                  herramientas de organización y guías paso a paso para que
                  nunca vuelvas a preguntarte qué cocinar.
                </p>

                <ul className="mt-7 grid gap-x-5 gap-y-2.5 sm:grid-cols-2" data-id="element-249" data-mp="3r8wn9e3hhrct">
                  {['Guía principal Código Fitness™', 'Cocina Antiinflamatoria', 'Recetario Déficit Calórico', 'Planificador Nutricional', 'Más de 550 recetas saludables', 'Calendario de alimentación de 30 días', 'Meal Prep', 'Listas inteligentes', 'Acceso inmediato', 'Compatible con celular, tablet y computadora'].map(benefit => <li key={benefit} className="flex items-start gap-2 text-sm leading-6 text-[#586655]" data-id="element-250" data-mp="102xawwxhzis4">
                      <CheckIcon className="mt-1 shrink-0 text-[#719063]" size={14} strokeWidth={2} data-id="element-251" data-mp="ma7bnqsykhd2" />
                      <span data-id="element-252" data-mp="cc1dnka9vvdh">{benefit}</span>
                    </li>)}
                </ul>

                <div className="mt-8 inline-flex items-center gap-2 rounded-full border border-[#b9c9ad] bg-[#f2f6ed] px-4 py-2.5 text-xs font-bold tracking-[0.05em] text-[#486044]" data-id="element-253" data-mp="3d64bzbxm55y">
                  <CheckIcon size={15} strokeWidth={2} data-id="element-254" data-mp="7gvuuuc62wtm" />
                  Acceso inmediato después de tu compra
                </div>
              </div>
            </motion.aside>
          </div>

          <motion.aside initial={{
          opacity: 0,
          y: 18
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          amount: 0.2
        }} transition={{
          duration: 0.55
        }} className="mx-auto mt-16 max-w-5xl rounded-[22px] border border-[#c9d7c1] bg-[#dfe9d8] px-6 py-12 text-center shadow-[0_16px_38px_rgba(53,70,49,0.10)] sm:px-12 sm:py-16" aria-labelledby="launch-offer-title" data-id="element-255" data-mp="3fyv4v35tlw7r">
            <p className="mx-auto inline-flex rounded-full bg-[#657b5b] px-4 py-2 text-[10px] font-bold tracking-[0.18em] text-[#fff8e8]" data-id="element-256" data-mp="ciflkwzwefk3">
              🔥 OFERTA ESPECIAL DE LANZAMIENTO
            </p>

            <h3 id="launch-offer-title" className="font-display mx-auto mt-7 max-w-2xl text-3xl leading-tight text-[#30452e] sm:text-4xl" data-id="element-257" data-mp="lewzu93k6tk2">
              Empieza hoy a cuidar tu salud con una inversión mínima.
            </h3>

            <div className="mt-9" data-id="element-258" data-mp="17x5jyuk89lu7">
              <p className="text-lg font-medium text-[#7b8375] line-through" data-id="element-259" data-mp="12yktvnyowijh">
                $197 USD
              </p>
              <p className="font-display mt-1 text-6xl leading-none text-[#2f5432] sm:text-8xl" data-id="element-260" data-mp="f8gp3d9rmcqw">
                $29.99 USD
              </p>
            </div>

            <p className="mx-auto mt-7 max-w-3xl text-base leading-7 text-[#4c6049] sm:text-lg" data-id="element-261" data-mp="a7sqa5faorm4">
              No estás comprando un libro. Estás invirtiendo en un sistema
              completo que te acompañará cada día para construir hábitos
              saludables de forma sencilla, práctica y sostenible.
            </p>

            <div className="mt-7 flex flex-wrap justify-center gap-x-5 gap-y-2 text-sm font-semibold text-[#506548]" data-id="element-262" data-mp="3np1pw6s8tzix">
              <span data-id="element-263" data-mp="236hfyodvpyah">Ahorras más del 80%</span>
              <span aria-hidden="true" className="text-[#93a58b]" data-id="element-264" data-mp="234o9b939ne2h">
                •
              </span>
              <span data-id="element-265" data-mp="27zkaozue7ds9">Pago único</span>
              <span aria-hidden="true" className="text-[#93a58b]" data-id="element-266" data-mp="1t93b7m1bixy0">
                •
              </span>
              <span data-id="element-267" data-mp="1y6wjckm6m20x">Sin mensualidades</span>
              <span aria-hidden="true" className="text-[#93a58b]" data-id="element-268" data-mp="1y7xx4wul12mc">
                •
              </span>
              <span data-id="element-269" data-mp="2lv5xr1h2fni1">Acceso para siempre</span>
              <span aria-hidden="true" className="text-[#93a58b]" data-id="element-270" data-mp="2qwljywuzc020">
                •
              </span>
              <span data-id="element-271" data-mp="2cxc7a75zfo2s">Descarga inmediata</span>
            </div>

            <a href={checkoutUrl} onClick={handleCheckoutClick} className="mt-10 inline-flex min-h-16 items-center justify-center rounded-full bg-[#3f603d] px-8 text-center text-sm font-bold tracking-[0.06em] text-white shadow-[0_10px_20px_rgba(48,69,46,0.16)] transition duration-300 hover:-translate-y-0.5 hover:bg-[#304d30] hover:shadow-[0_14px_26px_rgba(48,69,46,0.22)] focus:outline-none focus:ring-2 focus:ring-[#496d46] focus:ring-offset-2 focus:ring-offset-[#dfe9d8]" data-id="element-272" data-mp="2gy5sutvycqsi">
              QUIERO MI SISTEMA CÓDIGO FITNESS™
            </a>

            <div className="mx-auto mt-8 flex max-w-3xl flex-wrap justify-center gap-x-6 gap-y-4 text-xs font-medium text-[#50614b]" data-id="element-273" data-mp="2tgrob5ni9sj3">
              <span className="inline-flex items-center gap-2" data-id="element-274" data-mp="2pfg5biz505jv">
                <LockKeyholeIcon size={15} aria-hidden="true" data-id="element-275" data-mp="2kg38q6igrk43" />
                Pago 100% seguro
              </span>
              <span className="inline-flex items-center gap-2" data-id="element-276" data-mp="2fggvhx2my3va">
                <ZapIcon size={15} aria-hidden="true" data-id="element-277" data-mp="2fj34m156crfm" />
                Acceso inmediato
              </span>
              <span className="inline-flex items-center gap-2" data-id="element-278" data-mp="2aka0gzbs2cs4">
                <DownloadIcon size={15} aria-hidden="true" data-id="element-279" data-mp="dp3sxeo5482e" />
                Descarga digital
              </span>
              <span className="inline-flex items-center gap-2" data-id="element-280" data-mp="8rc4wvqm963h">
                <MonitorSmartphoneIcon size={15} aria-hidden="true" data-id="element-281" data-mp="h6i44ca0i9hw" />
                Compatible con celular, tablet y computadora
              </span>
            </div>
          </motion.aside>

          <div className="mx-auto mt-8 max-w-6xl border-l-2 border-[#809675] bg-[#f7f8f2] px-7 py-7 sm:px-10" data-id="element-282" data-mp="pzlf8dx6qa9d">
            <p className="text-xs font-bold tracking-[0.18em] text-[#667d5c]" data-id="element-283" data-mp="uxmusovejrg3">
              VALOR TOTAL DEL SISTEMA
            </p>
            <div className="mt-4 grid gap-4 text-sm leading-6 text-[#53634e] sm:grid-cols-2 lg:grid-cols-4" data-id="element-284" data-mp="3ug61znwh7nuv">
              {['550+ recetas saludables', 'Plan de alimentación de 30 días', 'Herramientas prácticas para toda la vida', 'Acceso inmediato en celular, tablet y computadora'].map(value => <p key={value} className="flex items-start gap-2" data-id="element-285" data-mp="1ioagccy8qfl4">
                  <CheckIcon className="mt-1 shrink-0 text-[#6d8662]" size={15} strokeWidth={2} data-id="element-286" data-mp="1nmkcoqvpbm8b" />
                  <span data-id="element-287" data-mp="2rlqrmjm19hf0">{value}</span>
                </p>)}
            </div>
          </div>
        </div>
      </section>

      <section className="bg-[#fcfbf7] py-24 sm:py-32" data-id="element-288" data-mp="35m1k1r2zr42a">
        <div className="mx-auto max-w-7xl px-5 sm:px-8" data-id="element-289" data-mp="30mf61ffc9jsf">
          <div className="flex flex-col justify-between gap-6 sm:flex-row sm:items-end" data-id="element-290" data-mp="30km0y4kdj7mj">
            <div data-id="element-291" data-mp="3fhv4rxqv63v5">
              <p className="text-xs font-bold tracking-[0.2em] text-[#6d8063]" data-id="element-292" data-mp="3fhblodph99fj">
                APRENDE HACIENDO
              </p>
              <h2 className="font-display mt-5 text-4xl text-[#2d3b2c] sm:text-5xl" data-id="element-293" data-mp="3obhy7h7lmv16">
                ¿Qué aprenderás?
              </h2>
            </div>
            <p className="max-w-sm leading-7 text-[#64705f]" data-id="element-294" data-mp="3kao94kif7a6p">
              Pequeñas herramientas para hacer de la alimentación saludable una
              parte natural de tu vida.
            </p>
          </div>
          <div className="mt-12 grid gap-px border border-[#e1e3db] bg-[#e1e3db] sm:grid-cols-2 lg:grid-cols-3" data-id="element-295" data-mp="3t8q5gmr7lenn">
            {learning.map(([title, Icon]) => {
            const LearningIcon = Icon as typeof LeafIcon;
            return <div key={title as string} className="flex min-h-36 items-center gap-5 bg-[#fcfbf7] p-7" data-id="element-296" data-mp="6tkhqxrov6r5">
                  <LearningIcon className="text-[#658057]" size={24} strokeWidth={1.5} data-id="element-297" data-mp="btyo8bdn68n2" />
                  <span className="text-base font-medium text-[#465342]" data-id="element-298" data-mp="2s8ugywaexm4">
                    {title as string}
                  </span>
                </div>;
          })}
          </div>
        </div>
      </section>
    </>;
}